import { RouteRecordRaw } from 'vue-router'
// 路由

/**
 * meta:{
 *     title:'登录', 页面标题/菜单标题
 *     icon:'',     菜单图标
 *     hidden:true, 是否在菜单中以隐藏
 *     hiddenTab:true 是否在tab栏中隐藏
 *     permission: 菜单权限编码（对应localStorage中的permissionCodes）
 * }
 */

export const commonRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: () => import('@/layout/index.vue'),
    redirect: '/home',
    meta: {
      title: '首页',
      icon: 'dashboard',
    },
    children: [{
      path: '/home',
      name: 'home',
      component: () => import('@/views/Home/home.vue'),
      meta: {
        title: '首页',
        icon: '',
      },
    }]
  },
  // 登录
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login/index.vue'),
    meta: {
      title: '登录',
      icon: '',
      hidden: true,
      hiddenTab: true
    }
  },
  // 个人中心
  {
    path: '/user',
    component: () => import('@/layout/index.vue'),
    redirect: '/user/userInfo',
    meta: {
      title: '个人中心',
      icon: 'user',
      hidden: true,
      hiddenTab: true,
    },
    children: [{
      path: 'userInfo',
      name: 'userInfo',
      component: () => import('@/views/userCenter/userInfo.vue'),
      meta: {
        title: '个人中心',
        icon: '',
      },
    }]
  },
  //  系统管理
  {
    path: '/systemManage',
    component: () => import('@/layout/index.vue'),
    redirect: '/systemManage/chamberPermission',
    meta: {
      title: '系统管理',
      icon: 'system',
      permission: 'system:manage:view'  // 系统管理查看权限
    },
    children: [{
      path: 'chamberPermission',
      name: 'chamberPermissionList',
      component: () => import('@/views/systemManage/chamberPermission/list.vue'),
      meta: {
        title: '商会权限管理',
        icon: '',
        permission: 'system:permission:list'  // 权限列表查看权限
      },
    }, {
      path: 'list',
      name: 'pointConsumeConfigList',
      component: () => import('@/views/systemManage/pointConfig/list.vue'),
      meta: {
        title: '积分消耗配置列表',
        icon: '',
        permission: 'pointConsumeConfig:list'
      },
    }, {
      path: 'manage',
      name: 'pointConsumeConfigManage',
      component: () => import('@/views/systemManage/pointConfig/manage.vue'),
      meta: {
        title: '积分消耗配置管理',
        icon: '',
        permission: 'pointConsumeConfig:manage',
        hidden: true,
        hiddenTab: true,
      },
    }, {
      path: 'featureConfig',
      name: 'featureConfigList',
      component: () => import('@/views/systemManage/featureConfig/list.vue'),
      meta: {
        title: '功能配置管理',
        icon: '',
        permission: 'featureConfig:list'
      },
    }, {
      path: 'platformFunConfig',
      name: 'platformFunConfigList',
      component: () => import('@/views/systemManage/platformFunConfig/list.vue'),
      meta: {
        title: '平台功能配置',
        icon: '',
        permission: 'platformFunConfig:list'
      },
    },{
      path: "list",
      name: "TaskManageList",
      component: () => import("@/views/taskManage/list.vue"),
      meta: { title: "任务配置" }
    },
    {
      path: "detail",
      name: "TaskManageDetail",
      component: () => import("@/views/taskManage/detail.vue"),
      meta: { title: "任务详情", hidden: true }
    }, {
      path: "coopRole",
      name: "coopRoleList",
      component: () => import("@/views/coopRoleManage/list.vue"),
      meta: {
        title: "合作身份管理",
        icon: "",
        permission: "coopRole:list"
      }
    }, {
      path: "coopRoleInvite",
      name: "coopRoleInviteList",
      component: () => import("@/views/coopRoleManage/inviteList.vue"),
      meta: {
        title: "合作邀请记录",
        icon: "",
        permission: "coopRole:inviteList"
      }
    }, {
      path: "workspace",
      name: "workspaceComponentList",
      component: () => import("@/views/systemManage/workspace/list.vue"),
      meta: {
        title: "工作台组件管理",
        icon: "",
        permission: "workspaceComponent:list"
      }
    }, {
      path: "workspaceTypeConfig",
      name: "workspaceLayoutConfigList",
      component: () => import("@/views/systemManage/workspace/typeConfig.vue"),
      meta: {
        title: "工作台组件配置",
        icon: "",
        permission: "workspaceLayoutConfig:list"
      }
    }]
  },
  //  用户管理
  {
    path: '/users',
    component: () => import('@/layout/index.vue'),
    redirect: '/users/userList',
    meta: {
      title: '用户管理',
      icon: 'user',
      permission: 'user:manage:view'
    },
    children: [{
      path: 'userList',
      name: 'userList',
      component: () => import('@/views/userManage/list.vue'),
      meta: {
        title: '用户列表',
        icon: '',
        permission: 'user:permission:list'
      },
    }, {
      path: 'userD',
      name: 'userD',
      component: () => import('@/views/userManage/details.vue'),
      meta: {
        title: '用户详情',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'user:permission:details'
      },
    }]
  },
  //  agent管理
  {
    path: '/agent',
    component: () => import('@/layout/index.vue'),
    redirect: '/agent/skills',
    meta: {
      title: 'Agent管理',
      icon: 'ai',
      permission: 'agent:manage'
    },
    children: [{
      path: 'experts',
      name: 'experts',
      component: () => import('@/views/agentManage/experts/list.vue'),
      meta: {
        title: '专家管理',
        icon: '',
        permission: 'agent:manage:experts'
      },
    }, {
      path: 'skills',
      name: 'skills',
      component: () => import('@/views/agentManage/skills/list.vue'),
      meta: {
        title: '技能管理',
        icon: '',
        permission: 'agent:manage:skills'
      },
    }]
  },
  //  商会管理
  {
    path: '/chamber',
    component: () => import('@/layout/index.vue'),
    meta: {
      title: '商会管理',
      icon: 'user',
    },
    children: [{
      path: 'list',
      name: 'chamberList',
      component: () => import('@/views/chamberManage/list.vue'),
      meta: {
        title: '商会列表',
        icon: '',
        permission: 'manager:chamber:list'  // 商会列表查看权限
      },
    }, {
      path: 'detail',
      name: 'chamberManageDetail',
      component: () => import('@/views/chamberManage/detail.vue'),
      meta: {
        title: '商会详情',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'chamber:update'
      }
    }, {
      path: 'chamberDetail',
      name: 'chamberDetail',
      component: () => import('@/views/chamberManage/detail.vue'),
      meta: {
        title: '商会详情',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'chamber:update'
      }
    }, {
      path: 'position',
      name: 'chamberManagePosition',
      component: () => import('@/views/chamberManage/position/list.vue'),
      meta: {
        title: '职务管理',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'position:list'
      }
    }, {
      path: 'department',
      name: 'chamberManageDepartment',
      component: () => import('@/views/chamberManage/department/list.vue'),
      meta: {
        title: '部门管理',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'department:list'
      }
    }, {
      path: 'guests',
      name: 'chamberGuestsList',
      component: () => import('@/views/chamberManage/guests/list.vue'),
      meta: {
        title: '嘉宾管理',
        icon: '',
        permission: 'chamber:guest:list'
      }
    },{
      path: 'outlet',
      name: 'chamberManageOutlet',
      component: () => import('@/views/outletManage/list.vue'),
      meta: {
        title: '网点管理',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'outlet:list'
      }
    }, {
      path: 'memberApplication',
      name: 'memberApplicationList',
      component: () => import('@/views/chamberManage/memberApplication/list.vue'),
      meta: {
        title: '入会申请审核',
        icon: '',
        permission: 'application:list'  // 入会申请列表查看权限
      }
    }, {
      path: 'msglist',
      name: 'messageList',
      component: () => import('@/views/messageManage/message/list.vue'),
      meta: {
        title: '发送通知消息',
        icon: '',
        permission: 'message:list'
      }
    },
    {
      path: 'viewUsers',
      name: 'viewUsers',
      component: () => import('@/views/messageManage/viewUsers/views.vue'),
      meta: {
        title: '已读情况',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'message:list'
      }
    },
    {
      path: 'feelist',
      name: 'chamberMemberFeeList',
      component: () => import('@/views/chamberManage/fee/list.vue'),
      meta: {
        title: '会费缴纳记录',
        icon: '',
        permission: 'fee:list'
      }
    }, {
      path: 'feeconfig',
      name: 'chamberFeeConfig',
      component: () => import('@/views/chamberManage/fee/config.vue'),
      meta: {
        title: '会费缴纳配置',
        icon: '',
        permission: 'fee:config'
      }
    },  {
      path: 'guests/detail',
      name: 'chamberGuestsDetail',
      component: () => import('@/views/chamberManage/guests/detail.vue'),
      meta: {
        title: '嘉宾详情',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'chamber:guest:edit'
      }
    }, {
      path: 'chamberBatchCreate',
      name: 'chamberBatchCreate',
      component: () => import('@/views/chamberManage/batchCreate.vue'),
      meta: {
        title: '批量新增',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'chamber:edit'
      }
    }, {
      path: 'feesettle',
      name: 'chamberFeeSettle',
      component: () => import('@/views/chamberManage/fee/settle/settle.vue'),
      meta: {
        title: '商会缴费结算',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'fee:settle'
      }
    }, {
      path: 'member',
      name: 'chamberMemberManage',
      component: () => import('@/views/chamberManage/member/list.vue'),
      meta: {
        title: '商会成员管理',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'member:list'
      }
    }, {
      path: 'fee',
      name: 'chamberMemberFeeManage',
      component: () => import('@/views/chamberManage/fee/manage.vue'),
      meta: {
        title: '会费缴纳管理',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'fee:manage'
      }
    }, {
      path: 'feeList',
      name: 'chamberFeeList',
      component: () => import('@/views/chamberManage/fee/list.vue'),
      meta: {
        title: '缴费管理',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'fee:list'
      }
    }, {
      path: 'pointConsumeConfig',
      name: 'pointConsumeConfigList',
      component: () => import('@/views/chamberManage/pointConsumeConfig/list.vue'),
      meta: {
        title: '积分消耗配置',
        icon: '',
        permission: 'pointConsumeConfig:list'
      }
    }]
  },

  //  新闻资讯管理
  {
    path: '/news',
    component: () => import('@/layout/index.vue'),
    redirect: '/news/newsArticle',
    meta: {
      title: '新闻资讯管理',
      icon: 'form',
    },
    children: [{
      path: 'newsCategory',
      name: 'newsCategoryManage',
      component: () => import('@/views/newsManage/category/list.vue'),
      meta: {
        title: '栏目分类管理',
        icon: '',
        permission: 'admin:news:category:list'  // 栏目列表查看权限
      }
    }, {
      path: 'newsTag',
      name: 'newsTagManage',
      component: () => import('@/views/newsManage/tag/list.vue'),
      meta: {
        title: '标签字典管理',
        icon: '',
        permission: 'admin:news:tag:list'  // 标签列表查看权限
      }
    }, {
      path: 'newsArticle',
      name: 'newsArticleList',
      component: () => import('@/views/newsManage/article/list.vue'),
      meta: {
        title: '新闻资讯管理',
        icon: '',
        permission: 'news:list'  // 资讯列表查看权限
      }
    }, {
      path: 'newsArticle/edit',
      name: 'newsArticleEdit',
      component: () => import('@/views/newsManage/article/edit.vue'),
      meta: {
        title: '编辑资讯',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'news:edit'
      }
    }, {
      path: 'newsArticle/audit',
      name: 'newsArticleAudit',
      component: () => import('@/views/newsManage/article/audit.vue'),
      meta: {
        title: '新闻审核',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'news:audit'
      }
    }, {
      path: 'supplyDemand',
      name: 'supplyDemandList',
      component: () => import('@/views/newsManage/article/supplyDemandList.vue'),
      meta: {
        title: '供需管理',
        icon: '',
        permission: 'admin:supplyDemand:list'  // 供需列表查看权限
      }
    }, {
      path: 'supplyDemand/edit',
      name: 'supplyDemandEdit',
      component: () => import('@/views/newsManage/article/supplyDemandEdit.vue'),
      meta: {
        title: '编辑供需信息',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'news:supplyDemand:edit'
      }
    }]
  },
  //  活动管理
  {
    path: '/activity',
    component: () => import('@/layout/index.vue'),
    redirect: '/activity/list',
    meta: {
      title: '活动管理',
      icon: 'teaching',
    },
    children: [{
      path: 'list',
      name: 'activityList',
      component: () => import('@/views/activity/list.vue'),
      meta: {
        title: '活动列表',
        icon: '',
        permission: 'activity:list'  // 活动列表查看权限
      },
    }, {
      path: 'lotteryManage',
      name: 'lotteryManage',
      component: () => import('@/views/activity/lotteryConfigManage.vue'),
      meta: {
        title: '活动抽奖',
        icon: ''
      }
    },{
      path: 'penaltyList',
      name: 'penaltyList',
      component: () => import('@/views/penalty/list.vue'),
      meta: {
        title: '惩罚记录',
        icon: '',
        permission: 'penalty:list'  // 惩罚列表查看权限
      }
    },{
      path: 'detail',
      name: 'activityDetail',
      component: () => import('@/views/activity/detail.vue'),
      meta: {
        title: '活动详情',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'activity:detail'
      }
    }, {
      path: 'manage',
      name: 'activityManage',
      component: () => import('@/views/activity/manage.vue'),
      meta: {
        title: '活动报名管理',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'activity:manage'
      }
    }, {
      path: 'score',
      name: 'activityScore',
      component: () => import('@/views/activity/score.vue'),
      meta: {
        title: '活动评分查看',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'activity:score'
      }
    }, {
      path: 'seatManage',
      name: 'seatManage',
      component: () => import('@/views/activity/seatManage.vue'),
      meta: {
        title: '座位管理',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'activity:manage'
      }
    },{
      path: 'seatZoneManage',
      name: 'seatZoneManage',
      component: () => import('@/views/activity/seatZoneManage.vue'),
      meta: {
        title: '座位区域管理',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'activity:manage'
      }
    },{
      path: 'lottery',
      name: 'activityLottery',
      component: () => import('@/views/activity/lottery.vue'),
      meta: {
        title: '抽奖配置管理',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'activity:manage'
      }
    }]
  },
  {
    path: '/help',
    component: () => import('@/layout/index.vue'),
    meta: {
      title: '求助反馈管理',
      icon: 'report',
    },
    children: [{
      path: 'helpRequest',
      name: 'helpRequestList',
      component: () => import('@/views/helpManage/helpRequest/list.vue'),
      meta: {
        title: '求助列表',
        icon: '',
        permission: 'help:list'
      }
    }, {
      path: 'feedback',
      name: 'feedbackList',
      component: () => import('@/views/helpManage/feedback/list.vue'),
      meta: {
        title: '反馈列表',
        icon: '',
        permission: 'feedback:list'
      }
    }]
  },
  {
    path: '/alliance',
    component: () => import('@/layout/index.vue'),
    meta: {
      title: '联盟管理',
      icon: 'tree',
      permission: 'alliance:chambers'
    },
    children: [{
      path: 'list',
      name: 'allianceList',
      component: () => import('@/views/allianceManage/list.vue'),
      meta: {
        title: '联盟列表',
        icon: '',
        permission: 'alliance:list'
      }
    },{
      path: 'detail',
      name: 'allianceDetail',
      component: () => import('@/views/allianceManage/detail.vue'),
      meta: {
        title: '联盟设置',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'alliance:detail'
      }
    },
    {
      path: 'allidetail',
      name: 'allianceDetailShow',
      component: () => import('@/views/allianceManage/detail.vue'),
      meta: {
        title: '联盟设置',
        icon: '',
        permission: 'alliance:detail'
      }
    },{
      path: 'batchBind',
      name: 'allianceBatchBind',
      component: () => import('@/views/allianceManage/batchBind.vue'),
      meta: {
        title: '批量绑定商会',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'alliance:bind'
      }
    },{
      path: 'allianceChamberList',
      name: 'allianceChamberList',
      component: () => import('@/views/allianceManage/chamberList.vue'),
      meta: {
        title: '联盟商会',
        icon: '',
        permission: 'alliance:chambers'
      }
    }]
  },
  //  专委会管理
  {
    path: '/specialCommittee',
    component: () => import('@/layout/index.vue'),
    redirect: '/specialCommittee/list',
    meta: {
      title: '专委会管理',
      icon: 'venue'
    },
    children: [{
      path: 'list',
      name: 'specialCommitteeList',
      component: () => import('@/views/specialCommittee/list.vue'),
      meta: {
        title: '专委会列表',
        icon: '',
        permission: 'sc:list'  // 专委会列表查看权限
      },
    }, {
      path: 'detail',
      name: 'specialCommitteeDetail',
      component: () => import('@/views/specialCommittee/detail.vue'),
      meta: {
        title: '专委会详情',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'sc:detail'
      }
    }, {
      path: 'position',
      name: 'specialCommitteePosition',
      component: () => import('@/views/specialCommittee/position/list.vue'),
      meta: {
        title: '专委会职务管理',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'sc:position:list'
      }
    }, {
      path: 'member',
      name: 'specialCommitteeMember',
      component: () => import('@/views/specialCommittee/member/list.vue'),
      meta: {
        title: '专委会成员管理',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'sc:member:list'
      }
    }]
  },
  //  联络站管理
  {
    path: '/servicePoint',
    component: () => import('@/layout/index.vue'),
    redirect: '/servicePoint/list',
    meta: {
      title: '联络站管理',
      icon: 'station',
    },
    children: [{
      path: 'list',
      name: 'servicePointList',
      component: () => import('@/views/specialCommittee/servicePointList.vue'),
      meta: {
        title: '联络站列表',
        icon: '',
        permission: 'point:list'  // 联络站列表查看权限
      },
    }, {
      path: 'outletManage',
      name: 'outletManage',
      component: () => import('@/views/outletManage/list.vue'),
      meta: {
        title: '会员站点',
        icon: '',
        permission: 'point:list'
      },
    }, {
      path: 'detail',
      name: 'servicePointDetail',
      component: () => import('@/views/specialCommittee/servicePointDetail.vue'),
      meta: {
        title: '联络站详情',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'point:detail'
      }
    }, {
      path: 'position',
      name: 'servicePointPosition',
      component: () => import('@/views/specialCommittee/position/list.vue'),
      meta: {
        title: '联络站职务管理',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'point:position:list'
      }
    }, {
      path: 'member',
      name: 'servicePointMember',
      component: () => import('@/views/specialCommittee/member/list.vue'),
      meta: {
        title: '联络站成员管理',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'point:member:list'
      }
    }]
  },
  //  走访计划管理
  {
    path: '/visit',
    component: () => import('@/layout/index.vue'),
    redirect: '/visit/plan/list',
    meta: {
      title: '走访计划管理',
      icon: 'visit',
      permission: 'visit:list'
    },
    children: [{
      path: 'plan/list',
      name: 'visitPlanList',
      component: () => import('@/views/visit/plan/list.vue'),
      meta: {
        title: '走访计划列表',
        icon: '',
        permission: 'visit:list'  // 走访计划列表查看权限
      },
    }, {
      path: 'plan/edit',
      name: 'visitPlanEdit',
      component: () => import('@/views/visit/plan/edit.vue'),
      meta: {
        title: '编辑走访计划',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'visit:edit'
      }
    }, {
      path: 'plan/detail',
      name: 'visitPlanDetail',
      component: () => import('@/views/visit/plan/detail.vue'),
      meta: {
        title: '走访计划详情',
        icon: '',
        hidden: true,
        hiddenTab: true
      }
    }]
  },
  //  相亲档案管理
  {
    path: '/blindManage',
    component: () => import('@/layout/index.vue'),
    redirect: '/blindManage/list',
    meta: {
      title: '相亲档案管理',
      icon: 'user',
      permission: 'blind:list'  // 相亲档案列表查看权限
    },
    children: [{
      path: 'list',
      name: 'blindProfileList',
      component: () => import('@/views/blindManage/list.vue'),
      meta: {
        title: '相亲档案列表',
        icon: '',
        permission: 'blind:list'  // 相亲档案列表查看权限
      },
    }, {
      path: 'detail',
      name: 'blindProfileDetail',
      component: () => import('@/views/blindManage/detail.vue'),
      meta: {
        title: '相亲档案详情',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'blind:detail'  // 相亲档案详情查看权限
      },
    }]
  },
  //  Banner广告管理
  {
    path: '/bannerManage',
    component: () => import('@/layout/index.vue'),
    redirect: '/bannerManage/list',
    meta: {
      title: 'Banner广告管理',
      icon: 'nested',
      permission: 'banner:list'  // Banner列表查看权限
    },
    children: [{
      path: 'list',
      name: 'bannerAdList',
      component: () => import('@/views/bannerManage/list.vue'),
      meta: {
        title: 'Banner广告列表',
        icon: '',
        permission: 'banner:list'  // Banner列表查看权限
      },
    }]
  },

   //  邀请函模板管理
   {
    path: '/posterManage',
    component: () => import('@/layout/index.vue'),
    redirect: '/posterManage/templateManage',
    meta: {
      title: '邀请函',
      icon: 'nested',
    },
    children: [{
      path: 'templateManage',
      name: 'templateManage',
      component: () => import('@/views/invitationsMaterials/templateManage.vue'),
      meta: {
        title: '模板管理',
        icon: '',
        permission: 'poster:manage' 
      },
    },{
      path: 'materialsList',
      name: 'invitationsMaterialsList',
      component: () => import('@/views/invitationsMaterials/list.vue'),
      meta: {
        title: '素材列表',
        icon: '',
        permission: 'invitationsMaterials:list' 
      },
    },{
      path: 'posteredit',
      name: 'posteredit',
      component: () => import('@/views/poster/views/Editor.vue'),
      meta: {
        title: '模板编辑',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'poster:edit'  
      },
    }]
  },
  //  问卷调查管理
  {
    path: '/survey',
    component: () => import('@/layout/index.vue'),
    redirect: '/survey/list',
    meta: {
      title: '问卷调查管理',
      icon: 'form',
      permission: 'survey:list'
    },
    children: [{
      path: 'list',
      name: 'surveyList',
      component: () => import('@/views/survey/list.vue'),
      meta: {
        title: '问卷列表',
        icon: '',
        permission: 'survey:list'
      },
    }, {
      path: 'edit',
      name: 'surveyEdit',
      component: () => import('@/views/survey/edit.vue'),
      meta: {
        title: '编辑问卷',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'survey:edit'
      },
    }, {
      path: 'detail',
      name: 'surveyDetail',
      component: () => import('@/views/survey/detail.vue'),
      meta: {
        title: '问卷详情',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'survey:detail'
      },
    }, {
      path: 'responseList',
      name: 'surveyResponseList',
      component: () => import('@/views/survey/responestList.vue'),
      meta: {
        title: '提交记录',
        icon: '',
        permission: 'survey:response:list',
        hidden: true,
        hiddenTab: true,
      },
    }, {
      path: 'responseDetail',
      name: 'surveyResponseDetail',
      component: () => import('@/views/survey/responseDetail.vue'),
      meta: {
        title: '提交详情',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'survey:response:detail'
      },
    },{
      path: 'analyze',
      name: 'surveyAnalyze',
      component: () => import('@/views/survey/analyze.vue'),
      meta: {
        title: '提交数据',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'survey:response:detail'
      },
    },{
      path: 'pollList',
      name: 'pollList',
      component: () => import('@/views/pollManage/list.vue'),
      meta: {
        title: '投票列表',
        icon: '',
      },
    }, {
      path: 'pollEdit',
      name: 'pollEdit',
      component: () => import('@/views/pollManage/edit.vue'),
      meta: {
        title: '编辑投票',
        icon: '',
        hidden: true,
        hiddenTab: true
      },
    }, {
      path: 'pollDetail',
      name: 'pollDetail',
      component: () => import('@/views/pollManage/detail.vue'),
      meta: {
        title: '投票详情',
        icon: '',
        hidden: true,
        hiddenTab: true
      },
    }]
  },
  //  数字签到大屏（全屏展示，不需要布局）
  {
    path: '/digital/checkIn',
    name: 'checkInScreen',
    component: () => import('@/views/digital/checkIn/checkIn.vue'),
    meta: {
      title: '活动签到大屏',
      icon: '',
      hidden: true,
      hiddenTab: true
    }
  },
  //  抽奖大屏（全屏展示，不需要布局）
  {
    path: '/digital/lotteryDraw',
    name: 'lotteryDrawScreen',
    component: () => import('@/views/digital/lotteryDraw/lotteryDraw.vue'),
    meta: {
      title: '活动抽奖大屏',
      icon: '',
      hidden: true,
      hiddenTab: true
    }
  },
  {
    path: '/:path(.*)*',
    component: () => import('@/views/err/404.vue'),
    meta: {
      title: '404',
      icon: '',
      hidden: true,
      hiddenTab: true
    }
  },
  //  智能体管理
  {
    path: '/agentManage',
    component: () => import('@/layout/index.vue'),
    redirect: '/agentManage/skills',
    meta: {
      title: '智能体管理',
      icon: 'nested',
      permission: 'agent:manage'
    },
    children: [{
      path: 'experts',
      name: 'agentExpertsList',
      component: () => import('@/views/agentManage/experts/list.vue'),
      meta: {
        title: '专家管理',
        icon: '',
      },
    }, {
      path: 'skills',
      name: 'agentSkillsList',
      component: () => import('@/views/agentManage/skills/list.vue'),
      meta: {
        title: '技能管理',
        icon: '',
      },
    }]
  }
]